import React from "react";
import { Alert } from "react-bootstrap";

const ErrorComponent = ({ message }) => {
  return (
    <Alert variant="danger">
      <Alert.Heading>Error</Alert.Heading>
      {message != null ? <p>{message}</p> : <p>An unknown error occured</p>}
    </Alert>
  );
};

export default ErrorComponent;
